import { z } from 'zod';

export const TodayAppointmentDataSchema = z.object({
  id: z.string(),
  customer_name: z.string(),
  appointment_type_title: z.string(),
  appointment_type_color: z.string(),
  start_time: z.string(),
  end_time: z.string(),
  team_member_name: z.string().nullable(),
  status: z.string(),
});

export type TodayAppointmentData = z.infer<typeof TodayAppointmentDataSchema>;

export const PageViewsDataSchema = z.object({
  totalPageViews: z.number(),
  weeklyChange: z.number(),
  isPositive: z.boolean(),
  changeLabel: z.string(),
});

export type PageViewsData = z.infer<typeof PageViewsDataSchema>;

// Acquisition time series schemas
export const AcquisitionTimeSeriesRowSchema = z.object({
  date: z.string(), // Date string in format YYYY-MM-DD
  booked: z.number(),
  not_booked: z.number(),
});

export const AcquisitionTimeSeriesDataSchema = z.object({
  date: z.string(),
  booked: z.number(),
  notBooked: z.number(),
});

export type AcquisitionTimeSeriesRow = z.infer<typeof AcquisitionTimeSeriesRowSchema>;
export type AcquisitionTimeSeriesData = z.infer<typeof AcquisitionTimeSeriesDataSchema>;